<template>
    <div class="m-form m-form--label-align-right m--margin-top-20 m--margin-bottom-30">
        <div class="row align-items-center">
            <div class="col-xl-8 order-2 order-xl-1">
                <div class="form-group m-form__group row align-items-center">
                    <div class="col-md-4">
                        <div class="m-input-icon m-input-icon--left">
                            <input type="text" class="form-control m-input m-input--solid" :placeholder="$t('Search...')" v-model="filterText" @keyup.enter="doFilter">
                            <span class="m-input-icon__icon m-input-icon__icon--left">
                                <span>
                                  <i class="la la-search"></i>
                                </span>
                            </span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <button type="button" class="btn btn-primary" @click="doFilter">{{$t('Search')}}</button>
                        <!--<button type="button" class="btn btn-link" @click="resetFilter">{{$t('Reset')}}</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'BaseFilter',
  data () {
    return {
      filterText: ''
    }
  },
  methods: {
    doFilter () {
      this.$store.commit('loading/change', true)
      this.$emit('filter-set', this.filterText)
    },
    resetFilter () {
      this.$store.commit('loading/change', true)
      this.filterText = ''
      this.$emit('filter-reset')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/BaseFilter.vue